import styled from 'styled-components';

// Shared styles for ChatPanel components (Scene and DS)

export const CHATS_HEADER_HEIGHT = 36;

export const Base = styled.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	min-height: 0;
`;

export const Conversation = styled.div`
	position: relative;
	flex: 1;
	min-height: 0;
`;

export const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	min-height: 200px;
`;
